import React, {
    Dispatch,
    ReactNode,
    SetStateAction,
    createContext,
    useContext,
    useMemo,
    useState,
} from 'react';
import { AcquisitionsLoader } from '../../AcquisitionsLoader/AcquisitionsLoader';

interface ILoaderProviderProps {
    children: ReactNode;
}

interface ILoaderValue {
    setShouldRenderLoader: Dispatch<SetStateAction<boolean>>;
}

const LoaderContext = createContext<ILoaderValue>({
    setShouldRenderLoader: () => {},
});

/**
 * the AcquisitionsLoader renders on submit and validation has passed
 */
export default function LoaderProvider({ children }: ILoaderProviderProps) {
    const [shouldRenderLoader, setShouldRenderLoader] =
        useState<boolean>(false);

    return (
        <LoaderContext.Provider
            value={useMemo(
                () => ({
                    setShouldRenderLoader,
                }),
                [],
            )}
        >
            {shouldRenderLoader ? (
                <AcquisitionsLoader
                    processingSteps={['Matching your profile', 'Checking your eligibility']}
                />
            ) : (
                children
            )}
        </LoaderContext.Provider>
    );
}

export const useLoader = () => useContext(LoaderContext);
